import { StoreCheckIcon } from './StoreCheckIcon';

/**
 * author: Colton Wiscombe
 * id 37B5401A-4A00-47AF-AF1D-678AB4C502FD
 * name store-check
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-check.svg
 * tags
 * - Shopping 
 * - Places 
 */
export const ShopCompleteIcon = StoreCheckIcon;
export default ShopCompleteIcon